import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { IntoxicationReadData, IntoxicationReadLabel } from '../intoxicationSchemas';
import type { IOsasReferralData } from './osasReferralSchema';
import { intoxicationsReadItems } from '../intoxicationSchemas';

export type OsasReferralReadLabel =
    | 'Straat'
    | 'Huisnummer'
    | 'Postcode'
    | 'Plaats'
    | 'Land'
    | 'Verstuurd naar'
    | 'Versturen naar'
    | 'Verwijsreden'
    | 'Belangrijkste klachten'
    | 'Is er sprake van relevante comorbiditeiten?'
    | 'Patiënt gebruikt(e) medicatie'
    | 'Medicatie'
    | 'Allergieën'
    | 'Episodes en journaalregels'
    | 'Diagnostische bepalingen'
    | 'Toelichting'
    | 'Tonsilgrootte'
    | 'Tonggrootte'
    | 'Retrognathie'
    | 'Dentitie goed gesaneerd'
    | 'Toelichting dentitie'
    | 'Gebitsprothese'
    | 'Gewicht / lengte / BMI'
    | 'Alcoholconsumptie'
    | 'Dagen per week / glazen per dag'
    | 'Gestopt sinds'
    | 'Roken'
    | 'Jaar / pakjes per dag / pack years'
    | 'Drugsgebruik'
    | 'Upload eventuele eerdere slaap- of bloedonderzoeken';

export type OsasReferralReadKey = keyof OsaReferralReadData;

export type OsaReferralReadData = IOsasReferralData & {
    alcoholConsumption: string[];
    days_a_week_glasses_a_day: string[];
    patientCity: string;
    patientCountry: string;
    patientHouseNumber: string;
    patientStreet: string;
    patientZip: string;
    referralSendTo: string;
    referralWillSendTo: string;
    weight_length_bmi: string[];
    years_packs: string[];
};

export const osasReferralReadSchema: TypedReadSchema<
    OsasReferralReadKey | keyof IntoxicationReadData,
    OsasReferralReadLabel | IntoxicationReadLabel
>[] = [
    {
        items: [
            { key: 'patientStreet', label: 'Straat' },
            { key: 'patientHouseNumber', label: 'Huisnummer' },
            { key: 'patientZip', label: 'Postcode' },
            { key: 'patientCity', label: 'Plaats' },
            { key: 'patientCountry', label: 'Land' },
        ],
        sectionTitle: 'Verstuur recorder naar adres',
    },
    {
        items: [
            { key: 'referralSendTo', label: 'Verstuurd naar' },
            { key: 'referralWillSendTo', label: 'Versturen naar' },
            { key: 'referralReason', label: 'Verwijsreden' },
            { key: 'importantComplaints', label: 'Belangrijkste klachten' },
            { key: 'comorbidities', label: 'Is er sprake van relevante comorbiditeiten?' },
        ],
        sectionTitle: 'Verwijzing',
    },
    {
        items: [
            { key: 'patientUsesMedication', label: 'Patiënt gebruikt(e) medicatie', type: 'boolean' },
            { key: 'medications', label: 'Medicatie' },
        ],
        sectionTitle: 'Medicatie',
    },
    {
        items: [
            { key: 'allergies', label: 'Allergieën' },
            { key: 'labResults', label: 'Diagnostische bepalingen' },
            { key: 'episodesAndJournals', label: 'Episodes en journaalregels' },
        ],
        sectionTitle: 'Professionele samenvatting',
    },
    {
        items: [
            { key: 'tonsilSize', label: 'Tonsilgrootte' },
            { key: 'tongueSize', label: 'Tonggrootte' },
            { key: 'retrognathism', label: 'Retrognathie' },
            { key: 'isDentitionWellSanitized', label: 'Dentitie goed gesaneerd' },
            { key: 'isDentitionWellSanitizedRemark', label: 'Toelichting dentitie' },
            { key: 'hasDentures', label: 'Gebitsprothese' },
        ],
        sectionTitle: 'Lichamelijk onderzoek',
    },
    {
        items: [{ key: 'weight_length_bmi', label: 'Gewicht / lengte / BMI' }, ...intoxicationsReadItems],
        sectionTitle: 'Leefstijl',
    },
    {
        items: [{ key: 'assets', label: 'Upload eventuele eerdere slaap- of bloedonderzoeken' }],
        sectionTitle: 'Relevante onderzoeken',
    },
];
